import { externalOperatorTags } from './externalOperator.tags';
import { createApi } from '@reduxjs/toolkit/query/react';
import { createBaseQueryWithReauth } from '@/services';
import { API_BUSINESS_URL } from '@/utils';

export const externalOperatorService = createApi({
  reducerPath: 'externalOperatorService',
  baseQuery: createBaseQueryWithReauth(`${API_BUSINESS_URL}`),
  tagTypes: [...externalOperatorTags],
  endpoints: () => ({}),
});
